import { createBrowserHistory, createHashHistory } from 'history';

const history = window.location.protocol.includes('file')
  ? createHashHistory()
  : createBrowserHistory();

export default history;
